import { render, staticRenderFns } from "./Headtitle.vue?vue&type=template&id=e223fafa&scoped=true&"
import script from "./Headtitle.vue?vue&type=script&lang=js&"
export * from "./Headtitle.vue?vue&type=script&lang=js&"
import style0 from "./Headtitle.vue?vue&type=style&index=0&id=e223fafa&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e223fafa",
  null
  
)

export default component.exports